export enum FeeBaseType {
    TicketAmount = 1,
    TicketPriceSum = 3,
}